import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const FooterBlock = ({ block }) => {
  const { 
    logo_url, 
    site_name, 
    tagline,
    email,
    phone,
    address,
    legal_links = [],
    social_links = []
  } = block.content;

  return (
    <footer className="border-t bg-muted/30" data-testid="footer">
      <div className="container px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Colonne 1 : Logo et Tagline */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              {logo_url && (
                <img 
                  src={logo_url} 
                  alt={site_name || 'Logo'} 
                  className="h-10 w-10 object-contain"
                />
              )}
              {site_name && (
                <span className="text-lg font-heading font-bold">
                  {site_name}
                </span>
              )}
            </Link>
            {tagline && (
              <p className="text-sm text-muted-foreground max-w-xs">
                {tagline}
              </p>
            )}
          </div>

          {/* Colonne 2 : Liens Légaux */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold">Informations Légales</h3>
            <ul className="space-y-2">
              {legal_links.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.url} 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 3 : Contact */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold">Contact</h3>
            <ul className="space-y-3">
              {email && (
                <li className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Mail className="h-4 w-4" />
                  <a 
                    href={`mailto:${email}`}
                    className="hover:text-foreground transition-colors"
                  >
                    {email}
                  </a>
                </li>
              )}
              {phone && (
                <li className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Phone className="h-4 w-4" />
                  <a 
                    href={`tel:${phone.replace(/\s/g, '')}`}
                    className="hover:text-foreground transition-colors"
                  >
                    {phone}
                  </a>
                </li>
              )}
              {address && (
                <li className="flex items-start gap-2 text-sm text-muted-foreground">
                  <MapPin className="h-4 w-4 mt-0.5" />
                  <span>{address}</span>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Réseaux Sociaux (optionnel) */}
        {social_links && social_links.length > 0 && (
          <div className="mt-8 pt-8 border-t">
            <div className="flex items-center justify-center gap-4">
              {social_links.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        )}

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} {site_name || 'Games Visor'}. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterBlock;
